export const locationKeysToStore = [
  'location',
  'latitude',
  'longitude',
  'state',
]
